var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"block block-kopf",class:[_vm.colClass]},[_c('span',{staticClass:"primary-headline-text"},[_vm._v(_vm._s(_vm.headline))])]),_c('div',{staticClass:"p-xl-2",class:['col-xl-' + (12 - _vm.col)]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }